import { TFunction } from 'i18next';
import { FIELD_LENGTH } from 'utils/constants';
import { TKeys } from 'utils/enums';
import { validateRequiredEnter } from 'utils/validation-schema';
import * as yup from 'yup';

export const loginValidationSchema = (t: TFunction) =>
    yup.object().shape({
        account: yup.string().required(t(TKeys.LBL010018)),
        password: yup
            .string()
            .required(t(TKeys.LBL010019))
            .min(
                FIELD_LENGTH.password,
                `パスワードは${FIELD_LENGTH.password}文字以上で入力してください`,
            ),
    });

export const contractSchema = (t: TFunction) => {
    return yup.object().shape({
        contract_code: validateRequiredEnter(t, t(TKeys.LBL010009)),
        authority_code: validateRequiredEnter(t, t(TKeys.LBL010011)),
    });
};
export const contractCodeSchema = (t: TFunction) => {
    return yup.object().shape({
        contract_code: validateRequiredEnter(t, t(TKeys.LBL010006)),
    });
};
